module.exports = "/fonts/vendor/mavon-editor/dist/fontello.eot?34a44d55b5494bbb008bcc8d54af225f";